export const INIT_RESTAURANT = "INIT_RESTAURANT";
export const INIT_RESTAURANTS = "INIT_RESTAURANTS";
export const SET_RESTAURANT_IMAGE = "SET_RESTAURANT_IMAGE";
